export class UsuarioModel {
    aceptoTerm?: boolean;
    apellidos?: string;
    colegio?: string;
    edades?: string;
    email?: string;
    id?: string;
    nombres?: string;
    password?: number;
    puesto?: string;
}

export class tipoGlobalInfo {
    pic?: string;
    ready?: boolean;
    situacion?: string;
    titulo?: string;
    urllive?: string;
    localconexion?: string;
}

